import React, {Component} from 'react'
import Select from 'react-select'
import moment from 'moment-timezone'
import GlobalHelper from "../GlobalHelper.jsx";

class TimeZoneSelect extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            options: GlobalHelper.getTimeZonePlusGMTFormat(),
            type: this.props.type || '',
            creatable : this.props.creatable || false,
            selectedOption: this.props.value || []
        }

        const defaultCallback = () => {}
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOption: selectedOption
        }, () => {
            this.onChange(selectedOption.value)
        });
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOption) {
            this.setState({
                selectedOption: nextProps.value || {}
            })
        }
    }

    render() {

        return (
            <Select
                name={this.name}
                placeholder={this.placeholder}
                value={this.state.selectedOption}
                onChange={this.handleChange}
                options={this.state.options}
                clearable={false}
            />
        )
    }
}

export default TimeZoneSelect





// WEBPACK FOOTER //
// ./src/common/date/timezoneselect.component.jsx